<template>
  <a-config-provider
    :locale="locale"
    :theme="{
      token: {
        colorPrimary: '#FB6E00',
      },
    }"
  >
    <a-spin :spinning="loadingState" size="large" style="min-height: 100vh">
      <router-view />
    </a-spin>
  </a-config-provider>
</template>
<script setup>
import zhCN from "ant-design-vue/es/locale/zh_CN";
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
import { computed, onMounted, ref } from "vue";
import { useStore } from "vuex";
// import DevicePixelRatio from "./utlis/devicePixelRatio";
dayjs.locale("zh-cn");
const store = useStore();
const locale = ref(zhCN);
const loadingState = computed(() => store.getters.getLoadingState);
onMounted(() => {
  // new DevicePixelRatio().init();
});
</script>

<style lang="scss"></style>
